import {BufferGeometry, CylinderGeometry, PlaneGeometry, SphereGeometry} from 'three'
import {mergeBufferGeometries} from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default class RoundedCubeGeometry extends BufferGeometry {
  constructor(radius = 0.1, segments = 4) {
    super()
    const _plane = new PlaneGeometry(1, 1)
    _plane.translate(0, 0, 0.5 + radius)

    const planeV0 = _plane.clone()
    const planeV1 = _plane.clone()
    planeV1.rotateY(Math.PI / 2)
    const planeV2 = _plane.clone()
    planeV2.rotateY(Math.PI)
    const planeV3 = _plane.clone()
    planeV3.rotateY(-Math.PI / 2)
    const planeV4 = _plane.clone()
    planeV4.rotateX(-Math.PI / 2)
    const planeV5 = _plane.clone()
    planeV5.rotateX(Math.PI / 2)

    const _sphere = new SphereGeometry(radius, segments, segments, 0, Math.PI * 0.5, 0, Math.PI * 0.5)
    _sphere.translate(-0.5, 0.5, 0.5)

    const sphere0 = _sphere.clone()
    const sphere1 = _sphere.clone()
    sphere1.rotateZ(Math.PI / 2)
    const sphere2 = _sphere.clone()
    sphere2.rotateZ(Math.PI)
    const sphere3 = _sphere.clone()
    sphere3.rotateZ(-Math.PI / 2)
    const sphere4 = sphere0.clone()
    sphere4.rotateY(Math.PI)
    const sphere5 = sphere1.clone()
    sphere5.rotateY(Math.PI)
    const sphere6 = sphere2.clone()
    sphere6.rotateY(Math.PI)
    const sphere7 = sphere3.clone()
    sphere7.rotateY(Math.PI)

    const _cylinder = new CylinderGeometry(radius, radius, 1, segments, 1, true, 0, Math.PI / 2)
    _cylinder.translate(0.5, 0.0, 0.5)
    const cylinder0 = _cylinder.clone()
    const cylinder1 = _cylinder.clone()
    cylinder1.rotateZ(Math.PI / 2)
    const cylinder2 = _cylinder.clone()
    cylinder2.rotateZ(Math.PI)
    const cylinder3 = _cylinder.clone()
    cylinder3.rotateZ(-Math.PI / 2)
    const cylinder4 = cylinder0.clone()
    cylinder4.rotateY(Math.PI)
    const cylinder5 = cylinder1.clone()
    cylinder5.rotateY(Math.PI)
    const cylinder6 = cylinder2.clone()
    cylinder6.rotateY(Math.PI)
    const cylinder7 = cylinder3.clone()
    cylinder7.rotateY(Math.PI)
    const cylinder8 = _cylinder.clone()
    cylinder8.rotateX(Math.PI / 2)
    const cylinder9 = cylinder8.clone()
    cylinder9.rotateZ(Math.PI / 2)
    const cylinder10 = cylinder8.clone()
    cylinder10.rotateZ(Math.PI)
    const cylinder11 = cylinder8.clone()
    cylinder11.rotateZ(-Math.PI / 2)

    const mergedGeometry = mergeBufferGeometries([
      planeV0,
      planeV1,
      planeV2,
      planeV3,
      planeV4,
      planeV5,
      sphere0,
      sphere1,
      sphere2,
      sphere3,
      sphere4,
      sphere5,
      sphere6,
      sphere7,
      cylinder0,
      cylinder1,
      cylinder2,
      cylinder3,
      cylinder4,
      cylinder5,
      cylinder6,
      cylinder7,
      cylinder8,
      cylinder9,
      cylinder10,
      cylinder11,
    ])

    this.copy(mergedGeometry)
  }
}
